import React from 'react';

const ShareGift = () => {
  return (
    <section id="share-gift">
      <div className="container">
        <div className="share-gift">
          <div className="percentage-circle">
            <div className="percentage-text">70%</div>
          </div>
          <h3>Share Gift</h3>
          <p>Dapatkan bagian 70% dari semua gift yang Anda terima selama live streaming!</p>
        </div>
      </div>
    </section>
  );
};

export default ShareGift;
